import type { Language } from "@point-of-sale/receipt-printer-encoder";
import type { DeviceConnectionTypes, PrinterLanguage } from "@repo/database";
import { createContext, useContext } from "react";

import type { Printer, PrintRoute } from "~/providers/printing-provider";

interface PrintingContext {
  getPrinterLanguage: (lang: PrinterLanguage) => Language;
  sendToPrinter: (
    data: Uint8Array,
    printer: {
      name: string;
      ipAddress?: string;
      port?: number;
      connectionType: DeviceConnectionTypes;
      systemName?: string;
    },
  ) => Promise<boolean>;
  printers: Printer[];
  printRoutes: PrintRoute[];
}

export const PrintingContext = createContext<PrintingContext | null>(null);

export const usePrinter = () => {
  const context = useContext(PrintingContext);
  if (context === null) {
    throw new Error(
      "usePrinter must be used within a PrintingProvider, but no provider was found",
    );
  }

  return context;
};
